<template>
  <div id="imperia_main_menu" role="navigation" :aria-label="LANG.mainMenu" v-if="visible !== null">
    <div id="imenu" :class="{ 'i-css-menu-visability-hidden': !visible }" role="application" :aria-label="LANG.mainMenu">
      <Menu @collapse="hideMainMenu" ref="topMenu" :items="left_menu.items" :expanded="true" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { imperiaHook } from '@/utils/tools';
import globals from '@/globals';
import { mapState, mapActions } from 'vuex';
import Menu from './Menu.vue';

const { context } = globals;

export default defineComponent({
  name: 'MainMenu',
  components: {
    Menu,
  },
  provide() {
    const { isFocusable } = this;
    return {
      $menuContext: () => ({
        isFocusable,
      }),
    };
  },
  created() {
    this.fetchLeftMenuData();
    this.fetchLeftMenuSettings();

    // sync the local `visible` state to the jQuery-managed state
    // See: site/view/imperia/default/layout/vue_mainmenu.html
    imperiaHook(($) => {
      this.visible = Boolean($('.i-main-menu-class').data('visible'));
      $(context.document).on('i-main-menu-toggle', this.onMenuToggle);
    });

    window.addEventListener('keydown', this.keyDownHandler);
  },
  unmounted() {
    imperiaHook(($) => $(context.document).off('i-main-menu-toggle', this.onMenuToggle));
    window.removeEventListener('keydown', this.keyDownHandler);
  },
  data() {
    return {
      visible: null,
    };
  },
  computed: {
    ...mapState(['LANG', 'left_menu']),
  },
  methods: {
    ...mapActions('left_menu', ['fetchLeftMenuData', 'fetchLeftMenuSettings']),
    /**
     * Disable keyboard navigation when the menu is not visible
     * @returns `true` if the item should be focusable in sequential keyboard navigation
     */
    isFocusable() {
      return this.visible;
    },
    hideMainMenu() {
      const hamburgerMenu = document.querySelector('.i-main-menu-class');
      if (hamburgerMenu) {
        hamburgerMenu.click();
        hamburgerMenu.focus();
        hamburgerMenu.classList.add('i-tab-focus');
      }
    },
    onMenuShow() {
      const hamburgerMenu = document.querySelector('.i-main-menu-class');
      const isToggleFocused = hamburgerMenu && hamburgerMenu.classList.contains('i-tab-focus');

      if (isToggleFocused) {
        const { topMenu } = this.$refs;
        if (topMenu) topMenu.open();
      }
    },
    onMenuToggle(_, { state }) {
      this.visible = state;
      if (this.visible) {
        this.onMenuShow();
      }
    },
    // Closes all menus by mutating state in place
    // FIXME: refactor state management and rely on top-down data flow
    dangerouslyCloseMenus() {
      const { items } = this.left_menu;
      if (!items || !Array.isArray(items)) return;

      // eslint-disable-next-line
      items.forEach((item) => { item.active = false; });
    },
    /**
     * handles `Esc` key events even when the element is not focused
     * @param {*} e
     */
    keyDownHandler(e) {
      if (e.key === 'Escape') {
        this.dangerouslyCloseMenus();
      }
    },
  },
});
</script>

<style scoped lang="scss">
:deep(i-tab-focus:focus),
:deep(.i-tab-focus) {
  outline: none;
  box-shadow: none;
}

:deep(.vue-focus:focus-visible) {
  outline: $i-tab-border;
  box-shadow: $i-tab-shadow;
}
</style>
